import { render } from "./HeaderButtons.vue?vue&type=template&id=66559964&scoped=true"
import script from "./HeaderButtons.vue?vue&type=script&lang=js"
export * from "./HeaderButtons.vue?vue&type=script&lang=js"

import "./HeaderButtons.vue?vue&type=style&index=0&id=66559964&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66559964"]])

export default __exports__